import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        'nav-close': 'closeNavigation',
      },
      pointerover: {
        item: 'setActiveLink',
      },
      pointerout: {
        item: 'unsetActiveLink',
      },
    };
  }

  closeNavigation() {
    this.call('closeNavigation', 'Header');
  }

  setActiveLink(e) {
    e.currentTarget.classList.add('-active');
  }

  unsetActiveLink(e) {
    e.currentTarget.classList.remove('-active');
  }
}
